/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import {ChangeFunction, Loader} from '@dvrd/dvr-controls';

import React from 'react';
import {useTranslation} from 'react-i18next';

import {BolmateDialog, BolmateTextarea} from '../controls';

interface Props {
    active: boolean;
    onClose: VoidFunction;
    onChangeFeedback: ChangeFunction<string>;
    onSubmit: VoidFunction;
    feedback: string;
    loading: boolean;
}

const FEEDBACK_PLACEHOLDER =
    'Voorbeeld A: "Sinds dinsdagochtend lukt het uploaden van facturen naar Bol niet meer. ' +
    "Bij bestelnummer 1234567890 krijg ik 'Factuur niet geaccepteerd'.\"\n\n" +
    'Voorbeeld B: "Ik zou het nice vinden als ik automatisch een e-mail kan ontvangen bij een retour."';

export default function FeedbackDialog(props: Props) {
    const {t} = useTranslation();
    const {active, onClose, onChangeFeedback, onSubmit, feedback, loading} = props;

    return (
        <BolmateDialog
            active={active}
            onClose={onClose}
            title={t('feedback.title', 'Feedback of probleem melden')}
            subtitle={t(
                'feedback.subtitle',
                'Laat ons weten wat er beter kan of wat er niet werkt. Geef ons duidelijke details.'
            )}
            className='feedback-dialog'
            onConfirm={onSubmit}
            confirmLabel={t('feedback.submit', 'Verzenden')}
            cancelLabel={t('feedback.cancel', 'Annuleren')}
            cancelVariant='tertiary'
            confirmDisabled={!feedback.trim().length}
            loading={loading}
        >
            <Loader active={loading} />
            <BolmateTextarea
                onChange={onChangeFeedback}
                value={feedback}
                placeholder={t('feedback.placeholder', FEEDBACK_PLACEHOLDER)}
                inputProps={{maxLength: 3000}}
                rows={8}
                fullWidth
            />
        </BolmateDialog>
    );
}
